/**
 * Checks if an object has a particular key and narrows the type of the object to one that guarantees the key exists.
 * @param obj - The object to check.
 * @param key - The key to check.
 * @returns `true` if the object has the key, `false` otherwise.
 */
export default function hasKey<T extends Record<string, unknown>>(
  obj: T,
  key: PropertyKey,
): key is keyof T {
  return key in obj;
}
